import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Grid } from '@mui/material';
import { Button, CopyButton, TextInput } from '@mantine/core';
import { useSelector } from 'react-redux';
const useStyles = makeStyles((theme) => ({
  root: {
    padding: '20px',
  },
}));

const baseUrl = `https://${window.location.origin.includes('testing') ? 'testing.' : ''}bpotech.io/`;

function MyLinks() {
  const classes = useStyles();
  const id = useSelector((state) => state.auth.marketerDetails.id);
  const links = [
    {
      label: 'General Link',
      value: `${baseUrl}advertise?affiliateId=${id}`,
    },
    {
      label: 'BPO Farm Link',
      value: `${baseUrl}advertise/advertise-farm?affiliateId=${id}`,
    },
    {
      label: 'BPO Premier Agent',
      value: `${baseUrl}advertise/advertise-premier?affiliateId=${id}`,
    },
    {
      label: 'BPO Deal Analyzer',
      value: `${baseUrl}advertise/advertise-deal?affiliateId=${id}`,
    },
  ];
  return (
    <>
      <Box className={classes.root}>
        <h2>Links</h2>
        <Box>
          <Grid container spacing={2}>
            {links.map(({ label, value }) => (
              <React.Fragment key={label}>
                <Grid item xl={10}>
                  <TextInput disabled sx={{ cursor: 'pointer' }} value={value} label={label} />
                </Grid>
                <Grid item xl={2} display="flex" alignItems="flex-end">
                  <CopyButton value={value}>
                    {({ copied, copy }) => (
                      <Button color={copied ? 'teal' : 'blue'} onClick={copy}>
                        {copied ? 'Copied url' : 'Copy url'}
                      </Button>
                    )}
                  </CopyButton>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
}

export default MyLinks;
